import { render } from "./homeTeachResearch.vue?vue&type=template&id=40096f42&scoped=true"
import script from "./homeTeachResearch.vue?vue&type=script&lang=js"
export * from "./homeTeachResearch.vue?vue&type=script&lang=js"

import "./homeTeachResearch.vue?vue&type=style&index=0&id=40096f42&lang=scss&scoped=true"

import exportComponent from "E:\\JzHyLyEdu\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40096f42"]])

export default __exports__